'use client';

import React from 'react';

export default function TeacherAboutSection({ profileData }) {
  return (
    <div className="bg-white rounded-lg border border-gray-200 shadow-sm">
      {/* Card Header */}
      <div className="px-6 py-4 border-b border-gray-200">
        <h2 className="text-2xl font-bold text-gray-900">
          About {profileData?.name || 'Teacher'}
        </h2>
      </div>
      
      {/* Card Content */}
      <div className="px-6 py-4">
        <div className="prose prose-gray max-w-none">
          <p className="text-gray-700 leading-relaxed whitespace-pre-line">
            {profileData?.about || profileData?.description || 'No detailed information available about this teacher.'}
          </p>
        </div>
      </div>
    </div>
  );
}